module.exports = __webpack_public_path__ + "img/BGProjectDetail.ac8db1db.jpg";